export default {"src":"/_next/static/media/shift4shop.e681700c.svg","height":83,"width":83,"blurWidth":0,"blurHeight":0};